export default __webpack_public_path__ + "static/media/logoFooter.ca38b6bd.png";